import * as React from "react";
import { Box, styled } from "@mui/system";
import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material";
import ParallaxComponent from "./entryScreenComponents/parallax";
import { useTranslation } from "react-i18next";
import entryImage from "../../../assets/entryImageTemp.jpg";

const updateLogs = [
  {
    title: "Version 0.06 Update",
    date: "2025-06-20",
    description:
      "Improved Visuals. Fixed several components and navigation patterns",
  },
  {
    title: "Version 0.05 Update",
    date: "2025-06-13",
    description:
      "Added water valve control for iot devices and alert settings for all devices. Added project and device addition",
  },
  {
    title: "Version 0.04 Update",
    date: "2025-06-01",
    description:
      "Added better support for phone UI. Added update feature for user info and device info",
  },
  {
    title: "Version 0.03 Update",
    date: "2025-05-01",
    description: "Added basic phone UI support. Added device alerts.",
  },
  {
    title: "Version 0.02 Update",
    date: "2025-04-01",
    description: "Added support to IoT Devices, which can now display & export history data.",
  },
  {
    title: "Version 0.01a Update",
    date: "2025-03-10",
    description: 'Renamed system to "GWIN". Changed logo.',
  },
  {
    title: "Version 0.01 Update",
    date: "2025-03-08",
    description:
      "Enhanced UI/UX, added landing page, implemented i18n support, fixed navigation issues, and refactored API routes.",
  },
  {
    title: "Version 0.00 Release",
    date: "2025-02-28",
    description:
      'Launched the initial system "Greenwalls iWeather Station" version with core features.',
  },
];

export default function ChangeLogScreen() {
  const { t } = useTranslation();
  return (
    <Box>
      <ParallaxComponent height={"50vh"} image={entryImage} title={t("changelog.title")} />
      <DescriptionSection>
        <DescriptionBox>
          <List>
            {updateLogs.map((log, index) => (
              <React.Fragment key={index}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='h6'>
                        {log.title} - {log.date}
                        {index === 0 && (
                          <Typography
                            variant='caption'
                            sx={{ color: "#ff4d4f", marginLeft: "4px" }}
                          >
                            {`(${t("changelog.new")})`}
                          </Typography>
                        )}
                      </Typography>
                    }
                    secondary={<Typography variant='body2'>{log.description}</Typography>}
                  />
                </ListItem>
                {index < updateLogs.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        </DescriptionBox>
      </DescriptionSection>
    </Box>
  );
}

const DescriptionSection = styled(Box)(({ theme }) => ({
  backgroundColor: "#E0E0E0",
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  paddingTop: "2em",
  paddingBottom: "2em",
  alignItems: "center",
  minHeight: "50vh",
}));

const DescriptionBox = styled(Box)(({ theme }) => ({
  width: "80%",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  rowGap: "5em",
}));
